import './Errors.css';

const NotFound = () => {
    return (
        <div className='notFound'>
            <h3>Sorry, page not found!</h3>
        </div>
    );
}

export default NotFound;